module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "serviceUnavailable"
  }, [_c('div', {
    staticClass: "serviceUnavailable-img"
  }, [_c('img', {
    staticClass: "serviceUnavailable-img-detail",
    attrs: {
      "src": require("../../assets/img/serviceUnavailable/503.png"),
      "alt": "网站正在维护"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "serviceUnavailable-content f24"
  }, [_vm._v("Error，网站正在维护，请稍后重试~")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cfb97e9"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/serviceUnavailable.vue
// module id = 689
// module chunks = 12